import { configureStore } from '@reduxjs/toolkit'
import mbSelectReducer from '../slices/mbSelectSlice'
import mwSelectReducer from '../slices/mwSelectSlice'


export const store = configureStore({
  reducer: {
    selector: mbSelectReducer,
    shower: mwSelectReducer,
  },
})